module.exports = __webpack_public_path__ + "img/account_info_hi.38f231e8.jpg";